const tw = {
  comments: {
    username: '姓名',
    email: 'E-mail',
    submit: '送出',
    loginToContinue: '留言請先登入',
    replyComment: '回覆',
    loadMoreComments: '讀取更多留言',
    private: '私密留言',
    public: '我願意將此提問公開，讓其他人也可以參考提問與回答',
    contentIsEmpty: '請填寫留言提問的內容。',
    recaptchIsNotChecked: '請完成我不是機器人的檢查。',
    qaTitle: '常見問題',
    platformQuestion: '平台問題',
    contestQuestion: '比賽問題',
    goToQuestion: '我要發問',
    similarCommentNeedReviewingTitle: '你的留言需要審核',
    similarCommentNeedReviewingContent: '你剛才留言太多次了，內容又有點類似，小酒館需要先審核你的留言，若審核通過才會發表喔。'
  }
}

module.exports = tw




// WEBPACK FOOTER //
// ./src/locales/tw.js